import React from "react";
import {
  TextField,
  NumberField,
  Paragraph,
  Dropdown,
  Checkbox,
  Toggle,
  RadioButton,
  Link,
  DateTime,
} from "./CustomizedComponent";

function ComponentPreview({ componentParameter, dropdownOptions, setComponentParameter }) {

  const getComponent = () => {
    switch (componentParameter.componentType) {
      case "text":
        return <TextField componentParameter={componentParameter} setComponentParameter={setComponentParameter} />;
      case "number":
        return <NumberField componentParameter={componentParameter} setComponentParameter={setComponentParameter} />;
      case "paragraph":
        return <Paragraph componentParameter={componentParameter} setComponentParameter={setComponentParameter} />;
      case "dropdown":
        return (
          <Dropdown componentParameter={componentParameter} setComponentParameter={setComponentParameter} dropdownOptions={dropdownOptions} />
        );
      case "check box":
        return <Checkbox {...componentParameter} />;
      case "toggle":
        return <Toggle {...componentParameter} />;
      case "radio group":
        return <RadioButton {...componentParameter} setComponentParameter={setComponentParameter} dropdownOptions={dropdownOptions} />;
      case "link":
        return <Link {...componentParameter} />;
      case "date/time":
        return <DateTime componentParameter={componentParameter} setComponentParameter={setComponentParameter}  />;
      default:
        return null;
    }
  };

  return <div className="py-3">{getComponent()}</div>;
}

export default ComponentPreview;
